module.exports = __webpack_public_path__ + "img/IMG_1454_L_BlackMatted_MockedUp.1c3ff835.jpg";